<template>
    <div class="login-top">
        <div class="login-container">
            <h1 class="heading-1 login-container__heading">Mot de passe oublié ?</h1>
            <p>
                Renseignez votre adresse e-mail ci-dessous, et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>
            <form @submit.prevent="validateBeforeSubmit" v-if="!onSend">
                <div class="login-container__inline">
                    <div class="form-group">
                        <input type="email" class="form-control form-control-lg" v-model="form.email" placeholder="Saississez votre email..." />
                    </div>
                    <button v-show="!isMobile" type="submit" class="btn btn-dark btn-lg btn-block">Recevoir mon mail</button>
                    <button v-show="isMobile" type="submit" class="btn btn-dark btn-lg btn-block">Recevoir</button>
                </div>
                <span class="error" v-if="errors.email">{{ errors.email }}</span>
            </form>
            
            <div v-if="onSend">
                <p>Un mail vous a été envoyé.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            onSubmit: false,
            onSend: false,
            response: [],
            errors: [],
            form: {
                email: null,
            },
        }
    },
    methods: {
        ...mapActions([
            'setOnLoad'
        ]),
        async validateBeforeSubmit() {
            if (this.onSend) return

            this.errors = []

            if (!this.form.email) {
                this.errors['email'] = 'Email requis'
            } else if (!this.validEmail(this.form.email)) {
                this.errors['email'] = 'Valid email required'
            }

            if (!this.errors.length) {
                this.submit();
            }

            this.onSend = false
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        submit() {
            this.onSubmit = true
            this.setOnLoad(true)

            // Send email with token for login.
            this.$api.postForgetPassword({
                email: this.form.email
            }).then(response => {
                this.response  = response;
                this.setOnLoad(false);
                this.onSend = true;
            }).catch((response) => {
                this.errors.email = response.response.data.message
                this.setOnLoad(false);
                this.onSubmit = false;
                this.onSend = false;
            });
        }
    },
    computed: {
        isMobile() {
            return this.$vssWidth < 992
        },
    }
}

/*{
    // GET /someUrl
    this.$http.get('/someUrl').then(response => {
  
      // get body data
      this.someData = response.body;
  
    }, response => {
      // error callback
    });
  }*/
</script>

